export default {
  required: 'هذا الحقل مطلوب',
  email: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
  minLength: 'الحد الأدنى للطول هو {min} أحرف',
  maxLength: 'الحد الأقصى للطول هو {max} أحرف',
  min: 'الحد الأدنى للقيمة هو {min}',
  max: 'الحد الأقصى للقيمة هو {max}',
  numeric: 'يرجى إدخال رقم صحيح',
  integer: 'يرجى إدخال عدد صحيح',
  url: 'يرجى إدخال رابط صحيح',
  phone: 'يرجى إدخال رقم هاتف صحيح',
  password: {
    minLength: 'يجب أن تكون كلمة المرور على الأقل {min} أحرف',
    mismatch: 'كلمات المرور غير متطابقة',
    weak: 'كلمة المرور ضعيفة جداً',
    medium: 'قوة كلمة المرور متوسطة',
    strong: 'قوة كلمة المرور قوية'
  },
  confirmPassword: {
    required: 'يرجى تأكيد كلمة المرور',
    mismatch: 'كلمات المرور غير متطابقة'
  },
  date: {
    invalid: 'يرجى إدخال تاريخ صحيح',
    past: 'يجب أن يكون التاريخ في الماضي',
    future: 'يجب أن يكون التاريخ في المستقبل',
    min: 'يجب أن يكون التاريخ بعد {date}',
    max: 'يجب أن يكون التاريخ قبل {date}'
  },
  file: {
    required: 'يرجى اختيار ملف',
    maxSize: 'يجب ألا يتجاوز حجم الملف {size}',
    invalidType: 'نوع ملف غير صحيح. الأنواع المسموحة: {types}',
    tooMany: 'عدد كبير جداً من الملفات. الحد الأقصى: {max}'
  },
  select: {
    required: 'يرجى اختيار خيار'
  },
  checkbox: {
    required: 'يجب تحديد هذا الحقل'
  },
  custom: {
    unique: 'هذه القيمة موجودة بالفعل',
    exists: 'هذه القيمة غير موجودة',
    pattern: 'تنسيق غير صحيح'
  }
}

